module.exports = __webpack_public_path__ + "img/14.ee423303.jpg";